<template>
  <div class="login">
    <div class="washi-topbar content">
      <div class="logo" @click="$router.push({ name: 'home' })" />
    </div>
    <div class="body content">
      <LoginBody v-if="$route.name === 'login'" :check-action="checkAction" :change-password="changePassword" />
      <register v-if="$route.name === 'register'" :check-action="checkAction" />
      <div class="img" />
    </div>
  </div>
</template>

<script>
import LoginBody from '@/components/Login';
import register from '@/components/Register';
export default {
  name: 'LoginView',
  components: { LoginBody, register },
  data() {
    return {
      changePassword: false,
    };
  },
  async mounted() {
    await this.checkAction();
    if (this.$auth.isLogged()) {
      this.$router.push({ name: 'dashboard' });
    }
  },
  methods: {
    async checkAction() {
      const actionType = this.$route.query.action;
      if (actionType) {
        const token = this.$route.query.token;
        switch (actionType) {
          case 'sharing':
            if (this.$auth.isLogged()) {
              this.loading = true;
              await this.$store.dispatch('sharing.get', token);
            }
            break;
          case 'register':
            if (this.$auth.isLogged()) {
              return;
            }
            this.loading = true;
            await this.$store.dispatch('auth.verifEmail', this.$route.query.token);
            break;
          case 'password':
            if (this.$auth.isLogged()) {
              return;
            }
            this.changePassword = true;
            break;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.login {
  background: linear-gradient(90deg, white 0%, white 50%, #{colors.$lighter-yellow-color} 50%);
  min-height: 100vh;
  .washi-title {
    font-size: 72px;
    align-self: flex-start;
  }

  .washi-topbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 32px;
    height: 64px;
    .logo {
      width: 200px;
      background-image: url('../assets/Logo_Washi.svg?file-css');
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
}

.body {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  padding-top: 32px;

  .img {
    padding: 32px 128px;
    width: 50%;
    height: 50vh;
    box-sizing: border-box;
    background-image: url('../assets/login/login-illu.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

@media screen and (max-width: 1184px) {
  .login {
    background: #fff;

    .washi-topbar {
      padding: 18px 0 0 0;
      margin-left: 18px;
      box-sizing: border-box;

      .logo {
        width: 78px;
      }
    }
  }

  .body {
    margin-left: 18px;
    margin-right: 18px;
    padding-top: 20px;
    max-width: calc(100% - 34px);

    .img {
      display: none;
    }
  }
}
</style>
